import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useAssets } from "../context/AssetContext";
import AssetList from "../components/AssetList";

const AssetsPage = () => {
  const { isAuthenticated } = useAuth();
  const { fetchAssets } = useAssets();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return <div>Redirecting to login...</div>;
  }

  return <AssetList />;
};

export default AssetsPage;
